import React, { useEffect, useState } from "react";

import { Box, Text } from "@chakra-ui/react";
import WorkFlowAdmin from "./WorkflowsGrid";
import { commonStyle } from "../../styles/commonStyle";

function WorkFlowAdminMain() {
  const [workflowNumber, setworkflowNumber] = useState(0);

  return (
    <Box h={"90vh"} w={"95%"} m={"auto"}>
      <Box mt={"10px"} mb={"20px"} h={"10%"}>
        <Text fontWeight={500}>Workflow Library</Text>
        <Text color={"rgba(108, 114, 117, 0.75)"}>
        Manage and track all created workflows in one place
        </Text>
      </Box>
      <Box h={"90%"} overflowY="auto" sx={{ ...commonStyle.sx,scrollBehavior: "smooth", }}>
      <WorkFlowAdmin setworkflowNumber={setworkflowNumber} />

      </Box>

    </Box>
  );
}

export default WorkFlowAdminMain;
